/**
 * Превью строки каталога пряников.
 *
 * Берётся файл листа из блока `gingerbread.files.previewUrl`; если его нет —
 * общая лестница каталога товаров (превью файла печати, затем превью макета).
 */

import { ImagePreviewPlaceholder, ImagePreviewThumb } from '../../../components/ui/ImagePreviewThumb'
import { getMediaUrl } from '../../../utils/mediaUtils'
import { catalogRowPreview } from '../../products-v2/lib'
import { previewOf } from '../lib'
import type { GingerbreadRow } from '../types'

/** Вертикальная плитка (A4) шириной 32 CSS-пикселя: на экране с двойной плотностью — до 96 с запасом. */
const THUMBNAIL_WIDTH = 96

export interface ResolvedPreview {
  url: string
  resizable: boolean
  label: string
}

export function resolvePreview(row: GingerbreadRow): ResolvedPreview | null {
  const own = previewOf(row)
  if (own) {
    return {
      url: getMediaUrl(own, row.design?.design_code),
      // Адрес — основное фото макета (маршрут медиа макета умеет ресайз) либо маршрут тома.
      resizable: true,
      label: 'Превью листа',
    }
  }
  const fallback = catalogRowPreview(row)
  if (!fallback.media) return null
  return {
    url: getMediaUrl(fallback.media.url, row.design?.design_code),
    resizable: Boolean(fallback.media.resizable),
    label: fallback.sourceLabel,
  }
}

/** Вертикальное превью строки таблицы — тот же размер и ховер-зум, что у «Каталога макетов». */
export function GingerbreadThumb({ row }: { row: GingerbreadRow }) {
  const preview = resolvePreview(row)
  if (!preview) return <ImagePreviewPlaceholder />
  return (
    <span title={preview.label} className="inline-flex shrink-0">
      <ImagePreviewThumb
        src={preview.url}
        alt={`${preview.label}: ${row.article}`}
        thumbnailWidth={preview.resizable ? THUMBNAIL_WIDTH : undefined}
        // Фигура пряника квадратная: в портретной плитке вписываем целиком, а не обрезаем по бокам.
        fit="contain"
      />
    </span>
  )
}
